import React, { Fragment } from "react";
import logo from "./logo.svg";

const Spinner = () => {
  return (
    <Fragment>
      <img src={logo} alt="" className="App-logo" />
    </Fragment>
  );
};

export default Spinner;
